import { render } from "./TableForm.vue?vue&type=template&id=4da40a75"
import script from "./TableForm.vue?vue&type=script&lang=js"
export * from "./TableForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__